import { ActionTypes } from "../../constants/ActionTypes";

export const onGetGuid = () => {
    return {
        type: ActionTypes.GET_GUID,
    };
};

export const onGetGuidSuccess = (action: any) => {
    return {
        type: ActionTypes.GET_GUID_Success,
        payload: action.data
    };
};